import {useState} from 'react';
import Validations from '../../../AppValidation';
/**
 * Importación de las validaciones
 */
const { validation, objValidations, requiredValidationSelects } = Validations();

/**
 * @constant useForm contiene las variables que serán devueltas al formulario para que sean tratadas
 */
const useForm = () => {    

    /**
     * @constant objFields objeto que contiene todos los campos del formulario y sirve para manejar sus valores y estado.
     */
    const objFields = {
    'username': '',
    'password': '',
    };

    /**
     * Constaltes par alos campos
     */
    const [values, setValues] = useState({
        ...objFields,
    });

    const handleChange = (e, newValue, idObjeto) => {

        if(idObjeto){
            //OBJECTS
            setValues({
                ...values,
                [idObjeto]: newValue
            });
            
        
        }else{
            //INPUT TEXT
            let identificadorCampo = e.target.id;

            if(identificadorCampo === ""){
            identificadorCampo = e.target.name;
            }

            setValues({
                ...values,
                [identificadorCampo]: e.target.value
            });              
        }     
    };
    
    /**
     * Constantes para almacenar el estado de las validaciones
     */
    const [showAlert, setShowAlert] = useState(false);
    const [usernameValid, setUsernameValid] = useState(true);    
    const [passwordValid, setPasswordValid] = useState(true);    

    //Evento SCROLL
    const gotoElement = () =>
        window.scrollTo({
            top: (0,0),
            behavior: "smooth"
        });

    // Validación de los campos obligatorios
    const validarCamposObligatorios = () =>{

        let isValid = false;

        let usernameValidacion = true;
        usernameValidacion = validation(values.username, objValidations.dni)
        
        if(!usernameValidacion){
            usernameValidacion = validation(values.username, objValidations.nie)
        }
        
        setUsernameValid(usernameValidacion);

        let passwordValidacion = true;
        passwordValidacion = requiredValidationSelects(values.password);
        setPasswordValid(passwordValidacion);        

        if(usernameValidacion && passwordValidacion){
                isValid = true;
        }

        return isValid;
    }

    return {
        //HandleChanges
        handleChange, gotoElement, validarCamposObligatorios,
        //Values
        values, showAlert, setShowAlert,
        //validaciones
        usernameValid, passwordValid,
    };

};
export default useForm;